import { useContext, useEffect, useRef } from 'react'
import { createToaster } from '@ark-ui/react'
import { AppContext, AppContextType } from '@/AppContext'
import RootSnackbarRenderer from './RootSnackbarRenderer'

export const toaster = createToaster({
    placement: 'top',
    overlap: false,
    gap: 8,
})

function RootSnackbarController() {
    const { state } = useContext(AppContext) as AppContextType

    const lastShownSnackbarIndexRef = useRef<number>(-1)
    const isFirstEffect = useRef<boolean>(true)

    useEffect(() => {
        if (isFirstEffect.current) {
            isFirstEffect.current = false
            return
        }

        if (state.rootSnackbarHistory.length > 0) {
            const snackbarToShowIndex = state.rootSnackbarHistory.length - 1
            if (snackbarToShowIndex > lastShownSnackbarIndexRef.current) {
                lastShownSnackbarIndexRef.current = snackbarToShowIndex
                const snackbarData = state.rootSnackbarHistory[snackbarToShowIndex]
                if (snackbarData) {
                    toaster.create({
                        title: snackbarData.message,
                        type: snackbarData.severity || 'info',
                        duration: snackbarData.duration || 3000,
                    })
                }
            }
        }
    }, [state.rootSnackbarHistory])

    return <RootSnackbarRenderer />
}

export default RootSnackbarController
